import React, {Component} from 'react';
import {DASHBO_DOMAIN} from "../../settings/settings";

export class TermsAndConditions extends Component {
    render() {
        return (
            <div className="terms-section">
                <p>Al iniciar sesión, estás aceptando los términos de servicio y políticas de privacidad</p>
                <div className="terms-links">
                    <a href={`http:///${DASHBO_DOMAIN}/terminos_privacidad`} target="_blank" rel="noopener noreferrer">Términos
                        de servicio </a>
                    |
                    <a href={`http:///${DASHBO_DOMAIN}/terminos_privacidad`}
                       target="_blank" rel="noopener noreferrer"> Políticas de privacidad</a>
                </div>
            </div>
        )
    }
}